import { memo } from 'react'

import { cn } from '@/shared/lib/cn'
import { RatingOrHotelType } from '@/shared/ui/rating/RatingOrHotelType.tsx'

import { useOfferCardHotelNameWithRating } from '../../model/useOfferCardHotelNameWithRating.ts'
import { OfferCardInnerProps } from '../../types/OfferCardInnerProps.ts'

interface OfferCardHotelNameWithRatingProps extends OfferCardInnerProps {
	hotelNameClassName?: string
	ratingStarClassName?: string
}

/**
 * Show hotel name and rating
 *
 * @author Ivan Shchedrovskyi
 */
export const OfferCardHotelNameWithRating = memo(
	({
		offer,
		className,
		hotelNameClassName,
		ratingStarClassName
	}: OfferCardHotelNameWithRatingProps) => {
		const { hotelName, stars, hotelType } =
			useOfferCardHotelNameWithRating(offer)

		return (
			<div className={cn('ts-6 flex items-center gap-2 md:gap-4', className)}>
				<h2 className={hotelNameClassName}>{hotelName}</h2>
				<RatingOrHotelType
					stars={stars}
					hotelType={hotelType}
					starClassName={ratingStarClassName}
				/>
			</div>
		)
	}
)

OfferCardHotelNameWithRating.displayName = 'OfferCardHotelNameWithRating'
